






























































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import dialogComp from '@/components/dialog/index.vue';
import { Button } from 'mint-ui';
import qs from 'qs';
import loginDialog from '../login/index';
@Component<VBANNER>({
  components: {
    dialogComp,
    'mt-button': Button,
  },
})
export default class VBANNER extends Vue {
  public tipType: number = 0; /* 0是已参与过活动，1是未中奖 */
  public giftType: string = '';
  public voteList: any = [];
  public phone: string = '';
  public showResult: boolean = false;
  public id: string = '';
  public show() {
    (this.$refs.dialog as any).show();
    let timer = setTimeout(() => {
      clearTimeout(timer);
      this.showResult = true;
    }, 500);
  }
  public close() {
    this.showResult = false;
    (this.$refs.dialog as any).close();
  }
  public submit() {
    var reg = /^1[3456789]\d{9}$/gi;
    let dialog: any = (this as any).$dialog;
    if (!reg.test(this.phone)) {
      dialog.alert({
        message: '请输入正确的手机号',
      });
      return;
    }
    (this as any).$http({
      url:
        '/commonly/rePrzie?' +
        qs.stringify({
          phone: this.phone,
          id: this.id,
        }),
      type: 'get',
      data: {},
      config: { formType: true },
      login: loginDialog,
      success: (res: any) => {
        (this as any).$dialog.alert({
          message: '提交成功',
        });
        this.close();
      },
    });
  }
  public getMaxW(item: any) {
    let total = 0;
    this.voteList.forEach((vote: any) => {
      total += vote.num;
    });
    return (item.num / total) * 100;
  }
  public goUrl() {
    location.href =
      'https://event.qunar.com/qm/qunargiftnew/index.htm?activityNo=tongyongh5&bdsource=tongyong';
  }
  public callback() {}
  public goLottery() {
    this.callback();
    this.close();
  }
}
